// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.book {
  display: flex;
  position: relative;
  flex-direction: column;
}

.jumbotron {
  height: 400px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url("https://ljc-site.s3.us-east-2.amazonaws.com/img/boost-your.png");
}

.publish-text {
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  font-family: "Spartan", sans-serif;
  color: #1d3557;
  /* color: #a5e300; */
  font-size: 20px;
  padding: 50px;
  line-height: 1.7em;
  /* width: 50%; */
}

.publish-text::first-line {
  content: "|";
  font-size: 1.6rem;
  font-family: "Inconsolata", monospace;
  animation-name: blinky;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

@keyframes blinky {
  0% {
    opacity: 1;
  }
  20% {
    opacity: 1;
  }
  25% {
    opacity: 0;
  }
  90% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeImgIn {
  0% {
    opacity: 0;
    transform: translateY(0px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.shadowed {
  background: white;
  margin: 100px 100px 0 100px;
  padding: 20px;
  position: relative;
}

.shadowed::after {
  /* border-radius: 0 0 100px 100px; */
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.25);
  content: "";
  display: block;
  height: 150px;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;
}

/** Card Styles */
.container-for-books {
  padding: 40px 80px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background: white;
  /* background-attachment: fixed;
    background-image: url("https://ljc-site.s3.us-east-2.amazonaws.com/img/white-crack.jpeg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover; */
  background-image: url("https://ljc-site.s3.us-east-2.amazonaws.com/img/purple-gold.jpeg");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
}

.articles-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  padding: 5rem;
}

.articles-container > a > img {
  cursor: pointer;
  width: 35em;
  height: 15em;
  margin: 5px;
  border-radius: 4px;
  border: 1px solid rgba(0, 35, 70, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 35, 70, 0.2);
}

.articles-container > a > img:hover {
  z-index: 1;
  transform: translateY(-1px);
  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);
}

.articles-bar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 3rem;
}

@media screen and (max-width: 1680px) {
  .container {
    padding: 40px 0;
  }
}
.book-card-wrap {
  margin: 10px;
  transform: perspective(800px);
  transform-style: preserve-3d;
  cursor: pointer;
}

.book-card-wrap:hover .cardInfo {
  transform: translateY(0);
}

.book-card-wrap:hover .cardInfo p {
  opacity: 1;
}

.book-card-wrap:hover .cardInfo,
.book-card-wrap:hover .cardInfo p {
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.book-card-wrap:hover .cardInfo:after {
  transition: 5s cubic-bezier(0.23, 1, 0.32, 1);
  opacity: 1;
  transform: translateY(0);
}

.book-card-wrap:hover .book-cardBg {
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1), opacity 5s cubic-bezier(0.23, 1, 0.32, 1);
  opacity: 0.8;
}

.book-card-wrap:hover .book-cardBg1 {
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1), opacity 5s cubic-bezier(0.23, 1, 0.32, 1);
  opacity: 0.8;
}

.book-card-wrap:hover .cardBg2 {
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1), opacity 5s cubic-bezier(0.23, 1, 0.32, 1);
  opacity: 0.8;
}

.book-card-wrap:hover .book-card {
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow: rgba(255, 255, 255, 0.2) 0 0 40px 5px, white 0 0 0 1px, rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px, inset white 0 0 0 6px;
}

.book-card {
  position: relative;
  flex: 0 0 240px;
  width: 1000px;
  height: 420px;
  background-color: #333;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px, inset rgba(255, 255, 255, 0.5) 0 0 0 6px;
  transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
}

@media screen and (max-width: 1680px) {
  .book-card {
    width: 250px;
  }
}
.book-cardBg {
  background-image: url("https://ljc-site.s3.us-east-2.amazonaws.com/img/atd.png");
  opacity: 0.5;
  position: absolute;
  top: -20px;
  left: -20px;
  width: 100%;
  height: 100%;
  padding: 20px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95), opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
  pointer-events: none;
}

.book-cardBg1 {
  background-image: url("https://ljc-site.s3.us-east-2.amazonaws.com/img/store.png");
  opacity: 0.5;
  position: absolute;
  top: -20px;
  left: -20px;
  width: 100%;
  height: 100%;
  padding: 20px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95), opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
  pointer-events: none;
}

.cardBg2 {
  background-image: url("https://ljc-site.s3.us-east-2.amazonaws.com/img/speaking.png");
  opacity: 0.5;
  position: absolute;
  top: -20px;
  left: -20px;
  width: 100%;
  height: 100%;
  padding: 20px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95), opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
  pointer-events: none;
}

.cardTitle {
  font-size: 22px;
}

.cardInfo {
  padding: 20px;
  position: absolute;
  bottom: 0;
  width: 100%;
  color: #fff;
  transform: translateY(40%);
  transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.cardInfo p {
  font-size: 20px;
  opacity: 0;
  font-family: "Spartan", sans-serif;
  text-shadow: black 0 2px 3px;
  transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.cardInfo * {
  position: relative;
  z-index: 1;
  font-family: "Spartan", sans-serif;
}

.cardInfo:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.8) 100%);
  background-blend-mode: overlay;
  opacity: 0;
  transform: translateY(100%);
  transition: 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
}

.cardInfo h1 {
  font-family: "Spartan", sans-serif;
  font-size: 36px;
  font-weight: 700;
  text-shadow: rgba(0, 0, 0, 0.5) 0 10px 10px;
}

@media (max-width: 500px) {
  .jumbotron {
    background-size: cover;
  }
  .shadowed {
    height: auto;
    margin: auto;
  }
  .articles-container {
    width: 23rem;
    margin: auto;
  }
  .articles-container > a > img {
    width: 25em;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Book/Styles.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kBAAA;EACA,sBAAA;AACJ;;AAEE;EACE,aAAA;EACA,WAAA;EACA,0CAAA;EACA,2BAAA;EACA,wBAAA;EACA,4BAAA;EACA,uFAAA;AACJ;;AAEE;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,kCAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AACJ;;AAEE;EACE,YAAA;EACA,iBAAA;EACA,qCAAA;EACA,sBAAA;EACA,sBAAA;EACA,iCAAA;EACA,mCAAA;AACJ;;AAEE;EACE;IACE,UAAA;EACJ;EACE;IACE,UAAA;EACJ;EACE;IACE,UAAA;EACJ;EACE;IACE,UAAA;EACJ;EACE;IACE,UAAA;EACJ;AACF;AAEE;EACE;IACE,UAAA;IACA,0BAAA;EAAJ;EAEE;IACE,UAAA;IACA,wBAAA;EAAJ;AACF;AAGE;EACE,iBAAA;EACA,2BAAA;EACA,aAAA;EACA,kBAAA;AADJ;;AAIE;EACE,oCAAA;EACA,wCAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;AADJ;;AAIE,iBAAA;AACA;EACE,kBAAA;EAEA,aAAA;EACA,eAAA;EAEA,uBAAA;EACA,iBAAA;EACA;;;;6BAAA;EAMA,yFAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFJ;;AAKE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;AAFJ;;AAKE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sCAAA;EACA,4CAAA;AAFJ;;AAKE;EACE,UAAA;EACA,2BAAA;EACA,8CAAA;AAFJ;;AAKE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AAFJ;;AAKE;EACE;IACE,eAAA;EAFJ;AACF;AAKE;EACE,YAAA;EAEA,6BAAA;EAEA,4BAAA;EACA,eAAA;AAHJ;;AAME;EAEE,wBAAA;AAHJ;;AAME;EACE,UAAA;AAHJ;;AAME;;EAGE,+CAAA;AAHJ;;AAME;EAEE,6CAAA;EACA,UAAA;EAEA,wBAAA;AAHJ;;AAME;EAGE,0FAAA;EAEA,YAAA;AALJ;;AAQE;EAGE,0FAAA;EAEA,YAAA;AAPJ;;AAUE;EAGE,0FAAA;EAEA,YAAA;AATJ;;AAYE;EAGE,6FAAA;EAEA,kJAAA;AAXJ;;AAgBE;EACE,kBAAA;EAEA,eAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6GAAA;EAGA,oDAAA;AAdJ;;AAgBE;EACE;IACE,YAAA;EAbJ;AACF;AAgBE;EACE,gFAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;EAGA,yGAAA;EAEA,oBAAA;AAhBJ;;AAmBE;EACE,kFAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;EAGA,yGAAA;EAEA,oBAAA;AAlBJ;;AAqBE;EACE,qFAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;EAGA,yGAAA;EAEA,oBAAA;AApBJ;;AAuBE;EACE,eAAA;AApBJ;;AAuBE;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EAEA,0BAAA;EAEA,yDAAA;AApBJ;;AAuBE;EACE,eAAA;EACA,UAAA;EACA,kCAAA;EACA,4BAAA;EAEA,yDAAA;AApBJ;;AAuBE;EACE,kBAAA;EACA,UAAA;EACA,kCAAA;AApBJ;;AAuBE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EAQA,qFAAA;EAKA,8BAAA;EACA,UAAA;EAEA,2BAAA;EAEA,uDAAA;AA9BJ;;AAiCE;EACE,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,2CAAA;AA9BJ;;AAiCE;EACE;IACE,sBAAA;EA9BJ;EAiCE;IACE,YAAA;IACA,YAAA;EA/BJ;EAkCE;IACE,YAAA;IACA,YAAA;EAhCJ;EAmCE;IACE,WAAA;EAjCJ;AACF","sourcesContent":[".book {\n    display: flex;\n    position: relative;\n    flex-direction: column;\n  }\n  \n  .jumbotron {\n    height: 400px;\n    width: 100%;\n    background-color: rgba(255, 255, 255, 0.5);\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-image: url(\"https://ljc-site.s3.us-east-2.amazonaws.com/img/boost-your.png\");\n  }\n  \n  .publish-text {\n    display: flex;\n    flex-direction: column;\n    /* justify-content: center; */\n    font-family: \"Spartan\", sans-serif;\n    color: #1d3557;\n    /* color: #a5e300; */\n    font-size: 20px;\n    padding: 50px;\n    line-height: 1.7em;\n    /* width: 50%; */\n  }\n  \n  .publish-text::first-line {\n    content: \"|\";\n    font-size: 1.6rem;\n    font-family: \"Inconsolata\", monospace;\n    animation-name: blinky;\n    animation-duration: 1s;\n    animation-timing-function: linear;\n    animation-iteration-count: infinite;\n  }\n  \n  @keyframes blinky {\n    0% {\n      opacity: 1;\n    }\n    20% {\n      opacity: 1;\n    }\n    25% {\n      opacity: 0;\n    }\n    90% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  \n  @keyframes fadeImgIn {\n    0% {\n      opacity: 0;\n      transform: translateY(0px);\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  .shadowed {\n    background: white;\n    margin: 100px 100px 0 100px;\n    padding: 20px;\n    position: relative;\n  }\n  \n  .shadowed::after {\n    /* border-radius: 0 0 100px 100px; */\n    box-shadow: 0 0 25px rgba(0, 0, 0, 0.25);\n    content: \"\";\n    display: block;\n    height: 150px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: -1;\n  }\n  \n  /** Card Styles */\n  .container-for-books {\n    padding: 40px 80px;\n    display: -webkit-box;\n    display: flex;\n    flex-wrap: wrap;\n    -webkit-box-pack: center;\n    justify-content: center;\n    background: white;\n    /* background-attachment: fixed;\n      background-image: url(\"https://ljc-site.s3.us-east-2.amazonaws.com/img/white-crack.jpeg\");\n      background-repeat: no-repeat;\n      background-position: center;\n      background-size: cover; */\n  \n    background-image: url(\"https://ljc-site.s3.us-east-2.amazonaws.com/img/purple-gold.jpeg\");\n    background-size: cover;\n    background-position: center;\n    background-attachment: fixed;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .articles-container {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    padding: 5rem;\n  }\n  \n  .articles-container > a > img {\n    cursor: pointer;\n    width: 35em;\n    height: 15em;\n    margin: 5px;\n    border-radius: 4px;\n    border: 1px solid rgba(0, 35, 70, 0.2);\n    box-shadow: 0 2px 2px 0 rgba(0, 35, 70, 0.2);\n  }\n  \n  .articles-container > a > img:hover {\n    z-index: 1;\n    transform: translateY(-1px);\n    box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);\n  }\n  \n  .articles-bar-section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: 3rem;\n  }\n  \n  @media screen and (max-width: 1680px) {\n    .container {\n      padding: 40px 0;\n    }\n  }\n  \n  .book-card-wrap {\n    margin: 10px;\n    -webkit-transform: perspective(800px);\n    transform: perspective(800px);\n    -webkit-transform-style: preserve-3d;\n    transform-style: preserve-3d;\n    cursor: pointer;\n  }\n  \n  .book-card-wrap:hover .cardInfo {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n  }\n  \n  .book-card-wrap:hover .cardInfo p {\n    opacity: 1;\n  }\n  \n  .book-card-wrap:hover .cardInfo,\n  .book-card-wrap:hover .cardInfo p {\n    -webkit-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1);\n    transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1);\n  }\n  \n  .book-card-wrap:hover .cardInfo:after {\n    -webkit-transition: 5s cubic-bezier(0.23, 1, 0.32, 1);\n    transition: 5s cubic-bezier(0.23, 1, 0.32, 1);\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n  }\n  \n  .book-card-wrap:hover .book-cardBg {\n    -webkit-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n      opacity 5s cubic-bezier(0.23, 1, 0.32, 1);\n    transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n      opacity 5s cubic-bezier(0.23, 1, 0.32, 1);\n    opacity: 0.8;\n  }\n  \n  .book-card-wrap:hover .book-cardBg1 {\n    -webkit-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n      opacity 5s cubic-bezier(0.23, 1, 0.32, 1);\n    transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n      opacity 5s cubic-bezier(0.23, 1, 0.32, 1);\n    opacity: 0.8;\n  }\n  \n  .book-card-wrap:hover .cardBg2 {\n    -webkit-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n      opacity 5s cubic-bezier(0.23, 1, 0.32, 1);\n    transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n      opacity 5s cubic-bezier(0.23, 1, 0.32, 1);\n    opacity: 0.8;\n  }\n  \n  .book-card-wrap:hover .book-card {\n    -webkit-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n      box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);\n    transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n      box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);\n    box-shadow: rgba(255, 255, 255, 0.2) 0 0 40px 5px, white 0 0 0 1px,\n      rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px,\n      inset white 0 0 0 6px;\n  }\n  \n  .book-card {\n    position: relative;\n    -webkit-box-flex: 0;\n    flex: 0 0 240px;\n    width: 1000px;\n    height: 420px;\n    background-color: #333;\n    overflow: hidden;\n    border-radius: 10px;\n    box-shadow: rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px,\n      inset rgba(255, 255, 255, 0.5) 0 0 0 6px;\n    -webkit-transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n    transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  }\n  @media screen and (max-width: 1680px) {\n    .book-card {\n      width: 250px;\n    }\n  }\n  \n  .book-cardBg {\n    background-image: url(\"https://ljc-site.s3.us-east-2.amazonaws.com/img/atd.png\");\n    opacity: 0.5;\n    position: absolute;\n    top: -20px;\n    left: -20px;\n    width: 100%;\n    height: 100%;\n    padding: 20px;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n    -webkit-transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95),\n      opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n    transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95),\n      opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n    pointer-events: none;\n  }\n  \n  .book-cardBg1 {\n    background-image: url(\"https://ljc-site.s3.us-east-2.amazonaws.com/img/store.png\");\n    opacity: 0.5;\n    position: absolute;\n    top: -20px;\n    left: -20px;\n    width: 100%;\n    height: 100%;\n    padding: 20px;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n    -webkit-transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95),\n      opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n    transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95),\n      opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n    pointer-events: none;\n  }\n  \n  .cardBg2 {\n    background-image: url(\"https://ljc-site.s3.us-east-2.amazonaws.com/img/speaking.png\");\n    opacity: 0.5;\n    position: absolute;\n    top: -20px;\n    left: -20px;\n    width: 100%;\n    height: 100%;\n    padding: 20px;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n    -webkit-transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95),\n      opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n    transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95),\n      opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n    pointer-events: none;\n  }\n  \n  .cardTitle {\n    font-size: 22px;\n  }\n  \n  .cardInfo {\n    padding: 20px;\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    color: #fff;\n    -webkit-transform: translateY(40%);\n    transform: translateY(40%);\n    -webkit-transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);\n    transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  \n  .cardInfo p {\n    font-size: 20px;\n    opacity: 0;\n    font-family: \"Spartan\", sans-serif;\n    text-shadow: black 0 2px 3px;\n    -webkit-transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);\n    transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  \n  .cardInfo * {\n    position: relative;\n    z-index: 1;\n    font-family: \"Spartan\", sans-serif;\n  }\n  \n  .cardInfo:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 0;\n    width: 100%;\n    height: 100%;\n    background-image: -webkit-gradient(\n      linear,\n      left top,\n      left bottom,\n      from(transparent),\n      to(rgba(0, 0, 0, 0.8))\n    );\n    background-image: linear-gradient(\n      to bottom,\n      transparent 0%,\n      rgba(0, 0, 0, 0.8) 100%\n    );\n    background-blend-mode: overlay;\n    opacity: 0;\n    -webkit-transform: translateY(100%);\n    transform: translateY(100%);\n    -webkit-transition: 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n    transition: 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  }\n  \n  .cardInfo h1 {\n    font-family: \"Spartan\", sans-serif;\n    font-size: 36px;\n    font-weight: 700;\n    text-shadow: rgba(0, 0, 0, 0.5) 0 10px 10px;\n  }\n  \n  @media (max-width: 500px) {\n    .jumbotron {\n      background-size: cover;\n    }\n  \n    .shadowed {\n      height: auto;\n      margin: auto;\n    }\n  \n    .articles-container {\n      width: 23rem;\n      margin: auto;\n    }\n  \n    .articles-container > a > img {\n      width: 25em;\n    }\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
